/* eslint-disable react-refresh/only-export-components -- MODES is data the
   panel and router share; splitting it from the icon frame helps nobody. */
// Mode icons for the side panel — the six KitchenOS modes. Drawn on
// lucide's 24-unit grid with the 1.75 stroke the header glyph uses;
// colourless in the panel, each takes its mode's accent on hover/active.
// Accents are food-natural tones within the Epicure palette family.

import type { ReactNode, SVGProps } from "react";

export interface ModeEntry {
  id: string;
  label: string;
  path: string;
  accent: string;
  icon: ReactNode;
}

/** Panel order. One group — no breaks needed for six entries. */
export const MODES: ModeEntry[] = [
  {
    id: "inventory",
    label: "Inventory",
    path: "/inventory",
    accent: "#a9d67f",
    icon: (
      // barcode in a scan frame
      <>
        <path d="M3 7V6a3 3 0 0 1 3-3h1M17 3h1a3 3 0 0 1 3 3v1M21 17v1a3 3 0 0 1-3 3h-1M7 21H6a3 3 0 0 1-3-3v-1" />
        <path d="M8 8v8M12 8v8M16 8v8" />
      </>
    ),
  },
  {
    id: "browse",
    label: "Browse",
    path: "/browse",
    accent: "#e8c987",
    icon: (
      // open recipe book
      <>
        <path d="M12 7a4 4 0 0 0-4-4H2v15h7a3 3 0 0 1 3 3" />
        <path d="M12 7a4 4 0 0 1 4-4h6v15h-7a3 3 0 0 0-3 3" />
        <path d="M12 7v14" />
      </>
    ),
  },
  {
    id: "cook",
    label: "Cook",
    path: "/cook",
    accent: "#f0997e",
    icon: (
      // pot with rising steam
      <>
        <path d="M4 11h16v6a3 3 0 0 1-3 3H7a3 3 0 0 1-3-3v-6Z" />
        <path d="M2 11h2M20 11h2" />
        <path d="M9 7.5c0-1 .8-1.2.8-2.2M13 7.5c0-1 .8-1.2.8-2.2M11 4.8c0-1 .8-1.2.8-2.2" />
      </>
    ),
  },
  {
    id: "menu",
    label: "Menu",
    path: "/menu",
    accent: "#9ec3e8",
    icon: (
      // week calendar
      <>
        <rect x="3" y="5" width="18" height="16" rx="2.5" />
        <path d="M8 3v4M16 3v4M3 10.5h18" />
        <path d="M8 14.5h.01M12 14.5h.01M16 14.5h.01M8 17.5h.01M12 17.5h.01" />
      </>
    ),
  },
  {
    id: "shopping",
    label: "Shopping",
    path: "/shopping",
    accent: "#f2c4a8",
    icon: (
      // basket with a ticked item
      <>
        <path d="M3 10h18l-1.6 8.2a2 2 0 0 1-2 1.8H6.6a2 2 0 0 1-2-1.8L3 10Z" />
        <path d="M8 10 11 3.5M16 10 13 3.5" />
        <path d="m9.5 14.5 1.8 1.8 3.4-3.6" />
      </>
    ),
  },
  {
    id: "discover",
    label: "Discover",
    path: "/discover",
    accent: "#dff6cd",
    icon: (
      // sparkle — new dishes
      <>
        <path d="M12 3.5 13.8 9a1.5 1.5 0 0 0 1 1L20 11.7a.4.4 0 0 1 0 .8L14.9 14a1.5 1.5 0 0 0-1 1l-1.7 5.6a.4.4 0 0 1-.8 0L9.7 15a1.5 1.5 0 0 0-1-1l-5.2-1.5a.4.4 0 0 1 0-.8L8.7 10a1.5 1.5 0 0 0 1-1L11.2 3.5a.4.4 0 0 1 .8 0Z" />
        <path d="M19 3v3M20.5 4.5h-3" />
      </>
    ),
  },
];

/** The 24-unit frame every mode icon is drawn in. */
export function ModeIcon({ children, ...props }: SVGProps<SVGSVGElement>) {
  return (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.75}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden
      {...props}
    >
      {children}
    </svg>
  );
}
